<template>
    <div>
    <index></index>

    </div>
</template>

<script>
import Index from '../components/Index.vue';

export default {
    components: {
        'index': Index,
    },
    data: function () {
        return {
            theme: 'light'
        };
    },

    created: function () {
        if (this.$store.state.theme === '') {
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                this.theme = 'dark';
            }
            localStorage.setItem('theme', this.theme);
            this.$store.commit('setTheme', this.theme);

        } else {
            this.theme = this.$store.state.theme;
        }
    },
    mounted: function () {
        this.toggleDarkMode();
    },
    methods: {
        toggleDarkMode: function () {

            // https://forum.vuejs.org/t/how-do-i-add-remove-classes-to-body/1219
            if (this.theme === 'dark') {
                document.documentElement.classList.add('theme-dark');
            } else {
                // Default light theme
                document.documentElement.classList.remove('theme-dark');
            }
        },

    },
    watch: {
        theme(newValue) {
            this.toggleDarkMode();
            localStorage.setItem('theme', newValue);
            this.$store.commit('setTheme', newValue);
        }
    },

}

</script>
